
export default {
  analysesContext: undefined,
  status: "",
  createStatus: '',
  errorContext: undefined,
  areaExpansionContext: null,
  statusAreaExpansion: '',
  yieldByYearContext: null,
  statusYieldByYear: '',
  statusScoreAreaComparative: '',
  statusComparativeScore: '',
  comparativeScoreContext: null,
  statusAnalysisSummary: '',
  analysisSummaryContext: null,
  statusAnalysisYieldEvolution: '',
  analysisYieldEvolutionContext: null,
  statusLastYearYield: '',
  lastYearYieldContext: null,
  statusAnalysisCropsStages: '',
  analysisCropsStagesContext:  null,
};
